import { ColumnDef } from "@tanstack/react-table";
import { Checkbox } from "@/components/ui/checkbox";
import { DataTableColumnHeader } from "@/components/ClientsheetTable/data-table-column-header";
import { InvoicePublic } from "@/components/InvoiceTable/schema";
import { getFileNameFromFilePath } from "@/lib/utils";
import { DownloadInvoiceButton } from "./DownloadInvoiceButton";

export const columns: ColumnDef<InvoicePublic>[] = [
  {
    id: "select",
    header: ({ table }) => (
      <Checkbox
        checked={table.getIsAllPageRowsSelected() || (table.getIsSomePageRowsSelected() && "indeterminate")}
        onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
        aria-label="Select all"
        className="translate-y-[2px]"
      />
    ),
    cell: ({ row }) => (
      <Checkbox
        checked={row.getIsSelected()}
        onCheckedChange={(value) => row.toggleSelected(!!value)}
        aria-label="Select row"
        className="translate-y-[2px]"
      />
    ),
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: "type",
    header: ({ column }) => (
      <div className="flex items-center justify-center">
        <DataTableColumnHeader column={column} title="Type" />
      </div>
    ),
    cell: ({ row }) => {
      return <div> {row.getValue("type")}</div>;
    },
  },
  {
    accessorKey: "month",
    header: ({ column }) => (
      <div className="flex items-center justify-center">
        <DataTableColumnHeader column={column} title="Month" />
      </div>
    ),
    cell: ({ row }) => {
      return <div> {row.getValue("month")}</div>;
    },
  },
  {
    accessorKey: "year",
    header: ({ column }) => (
      <div className="flex items-center justify-center">
        <DataTableColumnHeader column={column} title="Year" />
      </div>
    ),
    cell: ({ row }) => {
      return <div> {row.getValue("year")}</div>;
    },
  },
  {
    accessorKey: "id",
    header: ({ column }) => (
      <div className="flex items-center justify-center">
        <DataTableColumnHeader column={column} title="ID" />
      </div>
    ),
    cell: ({ row }) => <div>{getFileNameFromFilePath(row.getValue("id"))}</div>,
  },
  {
    accessorKey: "Download",
    enableSorting: false,
    header: ({ column }) => {
      return (
        <div className="flex items-center justify-center">
          <DataTableColumnHeader column={column} title="Download" />
        </div>
      );
    },
    cell: ({ row }) => {
      const id = row.getValue("id");

      if (typeof id !== "string") {
        return null;
      }

      return <DownloadInvoiceButton id={id} />;
    },
    filterFn: (row, id, value) => {
      return value.includes(row.getValue(id));
    },
  },
];
